module.exports = __webpack_public_path__ + "img/blog3.76f058db.jpg";